// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./components/auth/AuthContext";
import { useAuth } from "./components/auth/AuthContext";
import InstitutionLogin from "./components/auth/InstitutionLogin";
import InstitutionSignup from "./components/auth/InstitutionSignup";
import RegisterLearner from "./components/registration/RegisterLearner";
import RegisterParent from "./components/registration/RegisterParent";
import RegisterTeacher from "./components/registration/RegisterTeacher";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/common/Layout";
import AllStudents from "./pages/AllStudents";
import StudentDetails from "./pages/StudentDetails";
import AllTeachers from "./pages/AllTeachers";
import TeacherDetails from "./pages/TeacherDetails";
import AllParents from "./pages/AllParents";
import ParentDetails from "./pages/ParentDetails";
import ModifyClassResults from "./pages/ModifyClassResults";
import PublishEvent from "./pages/PublishEvent";
import PublishNews from "./pages/PublishNews";
import SchoolPerformance from "./pages/SchoolPerformance";
import PerformanceAnalysis from "./pages/PerformanceAnalysis";
import SchoolInteractions from "./pages/SchoolInteractions";
import CreatePost from "./pages/CreatePost";
import AmplifiedEventDetails from "./pages/AmplifiedEventDetails";
import AmplifiedEvents from "./pages/AmplifiedEvents";
import Scholarships from "./pages/Scholarships";
import ScholarshipDetails from "./pages/ScholarshipDetails";
import ScheduledExamDetails from "./pages/ScheduledExamDetails";
import ScheduleExam from "./pages/ScheduleExam";
import SchoolServices from "./pages/SchoolServices";
import FeeStructure from "./pages/FeeStructure";
import DeletedStudents from "./pages/DeletedStudents";
import SchoolSupportChat from "./pages/SchoolSupportChat";
import CareerInsights from "./pages/CareerInsights";
import UpdateFeeBalance from "./pages/UpdateFeeBalance";
import ReportIndiscipline from "./pages/ReportIndiscipline";
import SchoolProfile from "./pages/SchoolProfile";
import EditSchoolProfile from "./pages/EditSchoolProfile";
import AllEvents from "./pages/AllEvents";
import AllNews from "./pages/AllNews";
import Analysis from "./pages/Analysis";
import StudentDetailedAnalysis from "./pages/StudentDetailedAnalysis";
import EditClassLearners from "./pages/EditClassLearners";
import PromotionManagement from "./pages/PromotionManagement";
import AlumniManagement from "./pages/AlumniManagement";
import AlumniDetails from "./pages/AlumniDetails";
import TransferredLearners from "./pages/TransferredLearners";
import TransferredLearnerDetails from "./pages/TransferredLearnerDetails";

const PrivateRoute = ({ children }) => {
  const auth = useAuth();
  return auth.schoolId ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<InstitutionLogin />} />
          <Route path="/signup" element={<InstitutionSignup />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="register-learner" element={<RegisterLearner />} />
            <Route path="register-parent" element={<RegisterParent />} />
            <Route path="register-teacher" element={<RegisterTeacher />} />
            <Route path="all-students" element={<AllStudents />} />
            <Route path="student-details" element={<StudentDetails />} />
            <Route path="all-teachers" element={<AllTeachers />} />
            <Route path="teacher-details" element={<TeacherDetails />} />
            <Route path="parent-details" element={<ParentDetails />} />
            <Route path="all-parents" element={<AllParents />} />
            <Route path="all-parents" element={<AllParents />} />
            <Route
              path="modify-class-results"
              element={<ModifyClassResults />}
            />
            <Route path="publish-event" element={<PublishEvent />} />
            <Route path="publish-news" element={<PublishNews />} />
            <Route path="school-performance" element={<SchoolPerformance />} />
            <Route
              path="performance-analysis"
              element={<PerformanceAnalysis />}
            />
            <Route
              path="school-interactions"
              element={<SchoolInteractions />}
            />
            <Route path="create-post" element={<CreatePost />} />
            <Route
              path="amplified-event-details"
              element={<AmplifiedEventDetails />}
            />
            <Route path="all-amplified-events" element={<AmplifiedEvents />} />
            <Route path="all-scholarships" element={<Scholarships />} />

            <Route
              path="scholarship-details"
              element={<ScholarshipDetails />}
            />
            <Route
              path="scheduled-exam-details"
              element={<ScheduledExamDetails />}
            />
            <Route path="schedule-exam" element={<ScheduleExam />} />

            <Route path="school-services" element={<SchoolServices />} />
            <Route path="fee-structure" element={<FeeStructure />} />
            <Route path="deleted-students" element={<DeletedStudents />} />
            <Route path="school-support-chat" element={<SchoolSupportChat />} />
            <Route path="career-insights" element={<CareerInsights />} />
            <Route path="update-fee-balance" element={<UpdateFeeBalance />} />
            <Route
              path="report-indiscipline"
              element={<ReportIndiscipline />}
            />
            <Route path="school-profile" element={<SchoolProfile />} />
            <Route path="edit-school-profile" element={<EditSchoolProfile />} />
            <Route path="all-events" element={<AllEvents />} />
            <Route path="all-news" element={<AllNews />} />
            <Route path="analysis" element={<Analysis />} />
            <Route
              path="student-detailed-analysis"
              element={<StudentDetailedAnalysis />}
            />
            <Route
              path="/edit-class-learners"
              element={<EditClassLearners />}
            />
          </Route>
          <Route
            path="/promotion-management"
            element={<PromotionManagement />}
          />
          <Route path="/alumni-management" element={<AlumniManagement />} />
          <Route path="/alumni-details" element={<AlumniDetails />} />
          
          <Route
            path="/transferred-learners"
            element={<TransferredLearners />}
          />
          <Route
            path="/transferred-learner-details/:learnerId"
            element={<TransferredLearnerDetails />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
